import React, { useEffect, useState } from "react";
import "./App.css";
import { useSelector } from "react-redux";
import { Toaster } from "react-hot-toast";
import PublicRoutes from "./core/routes/PublicRoutes";
import PrivateRoutes from "./core/routes/PrivateRoutes";
import { Routes } from "react-router-dom";
import { AuthService } from "./modules/auth/Service";
import store from "./core/store";
import { refreshTokenSuccess } from "./core/store/auth/reducers";
import {
  loadAllModules,
  loadModules,
  loadPreferences,
} from "./core/store/company/reducers";
import GenerateUserModuleRoutes from "./core/routes/UserModuleRoutes";
import { SettingService } from "./modules/setting/Service";
import GenerateCustomerModuleRoutes from "./core/routes/CustomerModuleRoutes";
import GenerateInventoryModuleRoutes from "./core/routes/InventoryModuleRoutes";
import GeneratePurchaseModuleRoutes from "./core/routes/PurchaseModuleRoutes";
import GenerateSalesModuleRoutes from "./core/routes/SaleModuleRoutes";
import GenerateQuotationModuleRoutes from "./core/routes/QuotationModuleRoutes";
import GenerateAccountModuleRoutes from "./core/routes/AccountModuleRoutes";
import GenerateVariantModuleRoutes from "./core/routes/VariantModuleRoutes";

function App() {
  const [initialized, setInitialized] = useState(false);
  const userState = useSelector((state: any) => state.auth);
  const [authService] = useState(new AuthService());
  const [settingService] = useState(new SettingService());
  const company = useSelector((state: any) => state.company);
  const auth = useSelector((state: any) => state.auth);

  useEffect(() => {
    if (userState.token !== null && !initialized) {
      setInitialized(true);
    }
  }, [userState.token]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    console.log(token);
    if (token) {
      authService.refreshToken().then((res) => {
        if (res) {
          store.dispatch({
            type: refreshTokenSuccess,
            payload: res,
          });
          store.dispatch({
            type: loadModules,
            payload: res,
          });
        }
      });
    }
  }, []);

  // Load settings
  useEffect(() => {
    if (auth.token) {
      settingService.getPreferences().then((res: any) => {
        store.dispatch({
          type: loadPreferences,
          payload: res,
        });
      });
    }
    authService.allModules().then((res: any) => {
      store.dispatch({
        type: loadAllModules,
        payload: res,
      });
    });
  }, [auth.token]);

  return (
    <>
      <Routes>
        {PrivateRoutes.map((route, index) => {
          return route;
        })}
        {PublicRoutes.map((route, index) => {
          return route;
        })}
        {GenerateUserModuleRoutes().map((route: any, index: number) => {
          return route;
        })}
        {GenerateCustomerModuleRoutes().map((route: any, index: number) => {
          return route;
        })}
        {GenerateInventoryModuleRoutes().map((route: any, index: number) => {
          return route;
        })}
        {GeneratePurchaseModuleRoutes().map((route: any, index: number) => {
          return route;
        })}
        {GenerateSalesModuleRoutes().map((route: any, index: number) => {
          return route;
        })}
        {GenerateQuotationModuleRoutes().map((route: any, index: number) => {
          return route;
        })}
        {GenerateAccountModuleRoutes().map((route: any, index: number) => {
          return route;
        })}
        {GenerateVariantModuleRoutes().map((route: any, index: number) => {
          return route;
        })}
      </Routes>
      <Toaster />
    </>
  );
}

export default App;
